import React from "react";
import {Avatar, ListItem, ListItemAvatar, ListItemText} from "@material-ui/core";
import styled from "styled-components";
import ListItemProps from "../../Models/ListItemProps";
import ListItemsType from "../../Models/ListItemsType";
import markup from "../../Helper/markup";

const StyledAvatar = styled(Avatar)`
  background-color: #046A38 !important;
`;

interface DetailListItemProps extends ListItemProps<ListItemsType>{
    title: string;
    icon: any;
}

const DetailListItem =(props: DetailListItemProps) => {

    const {icon, title, item, onClick, showDivider} = props;

    const localOnClick = () => {
        if (onClick)
            onClick(item);
    };

    return (
        <ListItem
            button
            disableGutters
            onClick={localOnClick}
            divider={!!showDivider}
        >
            <ListItemAvatar>
                <StyledAvatar>
                    {icon}
                </StyledAvatar>
            </ListItemAvatar>
            <ListItemText>
                <p dangerouslySetInnerHTML={markup(title)} />
            </ListItemText>
        </ListItem>
    );
};

export default DetailListItem;